import $ from 'jquery';
import React, { Component } from 'react';
import Logger from 'js-logger';
import FastClick from 'fastclick';
import styled from 'styled-components';
import parseQueryParams from './lib/query-params';
import optimizePerformance from './lib/performance.jsx';
import { getStyleForCampaign } from './campaign/styles';
import getEnvironment from './lib/getEnvironment';
import { setLocale } from './lib/i18n';


// App routes
import Qa from './pages/qa.jsx';
import CampaignLoader from './campaign/campaign-loader.jsx';
import ReengagementOverview from './Reengagement/ReengagementOverview';


import {
    registrationAddress,
    registrationAddressChallengeId
} from './campaign/challenges/sevenPassLogin/config.js';

import './App.css';


Logger.useDefaults();
Logger.setLevel(Logger.DEBUG);


optimizePerformance();
setLocale(navigator.language.slice(0, 2));

$(() => FastClick.attach(document.body));

class App extends Component {
    state = {
        style: null,
    };

    onCampaignLoaded(campaign) {
        const style = campaign ? getStyleForCampaign(campaign) : null;
        this.setState({ style })
    };


    render() {
        // Simple replacement for ReactRouter etc. -- we don't need pushState support, as our
        // URL does not change like in other single page applications.

        // Splits the route into resource type (e.g. 'trackingtoken', 'placement') and value/id.
        // We allow the parameters to be supplied with or without hash syntax in the URL.
        const pathRegexp = /^#?\/?([^/]+)\/([^/]+)\/([^/?]+)/;
        const { hash, pathname } = window.location;
        const match = hash ? hash.match(pathRegexp) : pathname.match(pathRegexp);
        const hashQueryParamsString = (hash && (hash.match(/\?.*$/) || [])[0]) || '';
        const queryParams = Object.assign(
            parseQueryParams(window.location.search),
            parseQueryParams(hashQueryParamsString),
        );
        // TODO: Allow to specify 'normal' query params and hash query params at the same time,
        // mix them together
        if (match) {
            const [, env, resourceType, resourceValue] = match;
            const params = {
                env,
                environment: getEnvironment(env),
                resourceType,
                resourceValue,
                [resourceType]: resourceValue,
                queryParams
            };

            if (resourceType === 'reengagement') {
                return <ReengagementOverview params={params}/>
            }

            return (
                <CampaignLoader
                    style={this.state.style}
                    params={params}
                    className={this.props.className}
                    onCampaignLoaded={(campaign) => this.onCampaignLoaded(campaign)}
                />
            );
        } else if (pathname === '/login/cb') {
            // HACK: For some reasons, when 7pass redirects to /login/cb from Facebook
            // It returns some hash in the uri (e.g. 'http://localhost:3000/login/cb?code=MYCODE#_=_')
            // In our code we prioritize the hash data rather than the params,
            // So we need to get them back from the location
            //
            // What I'm going to do is to override this behaviour, so we will always get the params
            const code = queryParams.code || parseQueryParams(window.location.search).code;

            // check the localStorage and redirect
            if (localStorage) {
                // eslint-disable-next-line max-len
                window.location = `${window.localStorage.getItem(registrationAddress)}&code=${code}&challengeId=${localStorage.getItem(registrationAddressChallengeId)}`;
            } else {
                console.error('Something when wrong with the 7pass redirection [in the callback]');
            }
        } else if (pathname === '/qa') {
            return (<Qa className={this.props.className}/>);
        } else {
            return null;
        }
    }
}

const StyledApp = styled(App)``;

export default StyledApp;


// WEBPACK FOOTER //
// ./src/App.js